<p-table *ngIf="selectOrder" [value]="selectOrder?.orderItems">
  <ng-template pTemplate="header">
    <tr class="table-grey-bg">
      <th width="60px"></th>
      <th width="90px">Item Name</th>
      <th width="80px">Trade Type</th>
      <th width="100px">Initial Qty</th>
      <th width="100px">Initial Amount</th>
      <th
        width="150px"
        *ngIf="
          channel !== 'RECYKAL' &&
          !selectOrder.saleOrder &&
          selectOrder.orderType === 'PICKUP' &&
          status(
            [
              'PICKUP_SCHEDULED',
              'MATERIAL_PICKED',
              'MATERIAL_RECEIVED',
              'ORDER_COMPLETED'
            ],
            true
          )
        "
      >
        Picked Qty
      </th>
      <th
        width="100px"
        *ngIf="
          channel === 'RECYKAL' &&
          selectOrder.saleOrder &&
          selectOrder.orderType === 'PICKUP' &&
          status(
            ['MATERIAL_PICKED', 'MATERIAL_RECEIVED', 'ORDER_COMPLETED'],
            true
          )
        "
      >
        Picked Qty
      </th>
      <th
        width="85px"
        *ngIf="
          !selectOrder.saleOrder &&
          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true)
        "
      >
        Deductions
      </th>
      <th
        width="150px"
        *ngIf="
          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true) ||
          (selectOrder.orderType === 'DROP' &&
            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')
        "
      >
        {{ selectOrder?.saleOrder ? "Final" : "Received" }} Qty
      </th>
      <th
        width="65px"
        *ngIf="
          (!selectOrder.saleOrder &&
            status(['PICKUP_SCHEDULED', 'MATERIAL_RECEIVED'], true)) ||
          (selectOrder.orderType === 'DROP' &&
            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')
        "
      >
        Actions
      </th>
      <th width="100px">Amount</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-order>
    <tr class="custom-table-body">
      <td class="ion-text-center">
        <ion-img
          slot="start"
          style="width: 30px; margin-right: 10px"
          [src]="order.item.icon"
        ></ion-img>
      </td>
      <td style="line-height: 18px">
        <ion-text class="ion-float-left">{{ order?.item?.name }}</ion-text>
        <ion-text class="text-regular" color="medium"
          ><br />{{ order?.itemPrice | currency: "INR" }} /
          {{ order?.item?.unitType }}</ion-text
        >
        <!-- price-log approval info -->
        <ng-container *ngIf="order.priceLog" #actualTarget>
          <ion-icon
            pTooltip="More info"
            name="information-circle-outline"
            (click)="op.toggle($event, actualTarget)"
            class="info-circle"
          ></ion-icon>
          <p-overlayPanel #op [dismissable]="true">
            <div style="width: 300px">
              <ion-item lines="full">
                <ion-label
                  position="stacked"
                  class="text-regular"
                  color="medium"
                  >Approval Raised On</ion-label
                >
                <ion-text class="ion-float-left">{{
                  order.priceLog?.createdOn | date: "dd MMM yyyy, hh:mm a"
                }}</ion-text>
              </ion-item>
              <ion-item lines="full">
                <ion-label
                  position="stacked"
                  class="text-regular"
                  color="medium"
                  >Centre Incharge</ion-label
                >
                <ion-text class="ion-float-left">{{
                  order.priceLog?.createdByName
                }}</ion-text>
              </ion-item>
              <ion-item lines="full">
                <ion-label
                  position="stacked"
                  class="text-regular"
                  color="medium"
                  >Centre Name</ion-label
                >
                <ion-text class="ion-float-left">{{
                  selectOrder.toLocation?.name
                }}</ion-text>
              </ion-item>
              <ion-item lines="full">
                <ion-col slot="start">
                  <ion-label
                    position="stacked"
                    class="text-regular"
                    color="medium"
                    >Original Price</ion-label
                  >
                  <ion-text class="ion-float-left"
                    >{{ order.priceLog?.initialPrice | currency: "INR" }} /
                    {{ order?.item?.unitType }}</ion-text
                  ></ion-col
                >
                <ion-col>
                  <ion-label
                    position="stacked"
                    class="text-regular"
                    color="medium"
                    >Requested Price</ion-label
                  >
                  <ion-text class="ion-float-left"
                    >{{ order.priceLog?.proposalPrice | currency: "INR" }} /
                    {{ order?.item?.unitType }}</ion-text
                  ></ion-col
                >
              </ion-item>
              <ion-item lines="full">
                <ion-label
                  position="stacked"
                  class="text-regular"
                  color="medium"
                  >Comments</ion-label
                >
                <ion-text class="ion-float-left">{{
                  order.priceLog?.reason
                }}</ion-text>
              </ion-item>

              <ion-item
                lines="full"
                *ngIf="order.priceStatus && order.priceStatus === 'APPROVED'"
              >
                <ion-label
                  position="stacked"
                  class="text-regular"
                  color="medium"
                  >Approved On</ion-label
                >
                <ion-text class="ion-float-left">{{
                  order.priceLog?.updatedOn | date: "dd MMM yyyy, hh:mm a"
                }}</ion-text>
              </ion-item>
              <ion-item
                lines="full"
                *ngIf="order.priceStatus && order.priceStatus === 'APPROVED'"
              >
                <ion-col slot="start">
                  <ion-label
                    position="stacked"
                    class="text-regular"
                    color="medium"
                    >Supervisor</ion-label
                  >
                  <ion-text class="ion-float-left">{{
                    order.priceLog?.updatedByName
                  }}</ion-text></ion-col
                >
                <ion-col>
                  <ion-label
                    position="stacked"
                    class="text-regular"
                    color="medium"
                    >Modified price</ion-label
                  >
                  <ion-text class="ion-float-left"
                    >{{ order.priceLog?.approvedPrice | currency: "INR" }} /
                    {{ order?.item?.unitType }}</ion-text
                  ></ion-col
                >
              </ion-item>
              <ion-item
                lines="full"
                *ngIf="order.priceStatus && order.priceStatus === 'APPROVED'"
              >
                <ion-label
                  position="stacked"
                  class="text-regular"
                  color="medium"
                  >Comments</ion-label
                >
                <ion-text class="ion-float-left">{{
                  order.priceLog?.approvalReason
                }}</ion-text>
              </ion-item>
            </div>
          </p-overlayPanel>
        </ng-container>
      </td>
      <td>
        <ion-text class="ion-float-left" *ngIf="order?.tradeType === 'B'"
          >Buy</ion-text
        >
        <ion-text class="ion-float-left" *ngIf="order?.tradeType === 'S'"
          >Sale</ion-text
        >
      </td>
      <td>
        <ion-text>
          {{ order?.qty }} {{ order.item.unitType | titlecase }}</ion-text
        >
      </td>
      <td>
        <ion-text class="ion-float-left">{{
          order?.qty * order.itemPrice | currency: "INR"
        }}</ion-text>
      </td>
      <td
        *ngIf="
          !selectOrder.saleOrder &&
          selectOrder.orderType === 'PICKUP' &&
          status(
            [
              'PICKUP_SCHEDULED',
              'MATERIAL_PICKED',
              'MATERIAL_RECEIVED',
              'ORDER_COMPLETED'
            ],
            true
          )
        "
      >
        <ion-row>
          <ion-col size="12" class="ion-no-padding" d-flex>
            <ion-item
              border-radius-10=""
              *ngIf="order.isEdit && status(['PICKUP_SCHEDULED'], true)"
              class="edit-quantity-item"
              lines="none"
            >
              <ion-button
                min="0"
                color="medium"
                class="qty-btn minus-button ion-float-left"
                [disabled]="order.verifyQty <= 0"
                (click)="decr('verifyQty', order)"
              >
                <ion-icon name="remove"></ion-icon>
              </ion-button>
              <ion-input
                type="number"
                class="enter-quantity-input"
                (ionChange)="qtyChange('verifyQty', order)"
                min="0"
                [(ngModel)]="order.verifyQty"
              ></ion-input>
              <ion-button
                max="200"
                color="medium"
                class="qty-btn minus-button ion-float-right"
                (click)="incr('verifyQty', order)"
              >
                <ion-icon name="add"></ion-icon>
              </ion-button>
            </ion-item>
            <p *ngIf="isEdit">
              <ion-text text-small color="medium">{{
                order?.item?.unitType
              }}</ion-text>
            </p>
            <ion-text
              *ngIf="
                (!order.isEdit &&
                  status(
                    [
                      'PICKUP_SCHEDULED',
                      'MATERIAL_PICKED',
                      'MATERIAL_RECEIVED',
                      'ORDER_COMPLETED'
                    ],
                    true
                  )) ||
                (order.isEdit && status(['MATERIAL_RECEIVED'], true))
              "
              class="ion-float-left"
            >
              {{ order.verifyQty }} {{ order?.item?.unitType | titlecase }}
            </ion-text>
          </ion-col>
        </ion-row>
      </td>
      <td
        *ngIf="
          channel === 'RECYKAL' &&
          selectOrder.saleOrder &&
          selectOrder.orderType === 'PICKUP' &&
          status(
            ['MATERIAL_PICKED', 'MATERIAL_RECEIVED', 'ORDER_COMPLETED'],
            true
          )
        "
      >
        <ion-text class="ion-float-left">
          {{ order.verifyQty }} {{ order?.item?.unitType | titlecase }}
        </ion-text>
      </td>
      <td
        *ngIf="
          !selectOrder.saleOrder &&
          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true)
        "
      >
        <ion-text class="ion-float-left" *ngIf="!selectOrder.saleOrder">
          {{
            order.verifyQty - order.receivedQty > 0
              ? (order.verifyQty - order.receivedQty | number: "1.2-2")
              : 0
          }}
          {{ order.item.unitType | titlecase }}
        </ion-text>
        <ion-text
          class="ion-float-left"
          *ngIf="selectOrder.saleOrder && channel === 'RECYKAL'"
        >
          {{
            order.verifyQty - order.receivedQty > 0
              ? (order.verifyQty - order.receivedQty | number: "1.2-2")
              : 0
          }}
          {{ order.item.unitType | titlecase }}
        </ion-text>
      </td>
      <td
        *ngIf="
          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true) ||
          (selectOrder.orderType === 'DROP' &&
            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')
        "
      >
        <ion-row>
          <ion-col size="12" class="ion-no-padding" d-flex>
            <ion-item
              border-radius-10=""
              *ngIf="
                order?.isEdit &&
                (status(['MATERIAL_RECEIVED'], true) ||
                  selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')
              "
              class="edit-quantity-item"
              lines="none"
            >
              <ion-button
                min="0"
                class="qty-btn minus-button ion-float-left"
                [disabled]="order.receivedQty <= 0"
                (click)="decr('receivedQty', order)"
              >
                <ion-icon color="medium" name="remove"></ion-icon>
              </ion-button>
              <ion-input
                type="number"
                class="enter-quantity-input"
                (ionChange)="qtyChange('receivedQty', order)"
                min="0"
                [(ngModel)]="order.receivedQty"
              ></ion-input>
              <ion-button
                max="200"
                class="qty-btn minus-button ion-float-right"
                (click)="incr('receivedQty', order)"
              >
                <ion-icon color="medium" name="add"></ion-icon>
              </ion-button>
            </ion-item>
            <p *ngIf="isEdit">
              <ion-text text-small color="medium">{{
                order?.item?.unitType
              }}</ion-text>
            </p>
            <ion-text *ngIf="!order.isEdit" class="ion-float-left">
              {{ order.receivedQty }} {{ order?.item?.unitType | titlecase }}
            </ion-text>
            <!--            <ion-text *ngIf='!valid' class='invalid-style' font-regular>Enter only positive number.</ion-text>-->
          </ion-col>
        </ion-row>
      </td>
      <td
        *ngIf="
          (!selectOrder.saleOrder &&
            status(['PICKUP_SCHEDULED', 'MATERIAL_RECEIVED'], true)) ||
          (selectOrder.orderType === 'DROP' &&
            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')
        "
      >
        <div>
          <ion-icon
            color="dark"
            *ngIf="!order.isEdit"
            name="create"
            class="icon-size"
            (click)="order.isEdit = true"
          ></ion-icon>
          <ion-icon
            color="dark"
            *ngIf="order.isEdit"
            name="checkmark"
            class="icon-size"
            (click)="savePrice(order)"
          ></ion-icon>
        </div>
      </td>
      <td>
        <ion-text class="ion-float-left">{{
          order?.itemTotal | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" *ngIf="channel !== 'RECYKAL'">
    <tr
      class="border-box"
      *ngIf="
        selectOrder?.status === 'CREATED' ||
        selectOrder?.status === 'CANCELLED' ||
        selectOrder?.status === 'REJECTED' ||
        selectOrder?.status === 'HOLD' ||
        (selectOrder?.saleOrder && selectOrder?.status === 'PICKUP_SCHEDULED')
      "
    >
      <td class="no-border" [colSpan]="2"></td>
      <td class="no-border-right">
        <ion-text class="ion-float-end" color="dark">{{
          totalLabelText
        }}</ion-text>
      </td>
      <td [colSpan]="2" class="no-border-right no-border-left">
        <ion-text color="dark">{{ selectOrder?.totalQty }}Kg</ion-text>
      </td>
      <td class="no-border-left">
        <ion-text font-bold="" color="dark">{{
          totalAmount | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
    <tr class="border-box" *ngIf="selectOrder?.status === 'MATERIAL_PICKED'">
      <td [colSpan]="3" class="no-border"></td>
      <td class="no-border-right" [colSpan]="2">
        <ion-text class="ion-float-left" color="dark">{{
          totalLabelText
        }}</ion-text>
      </td>
      <td class="no-border-left no-border-right">
        <ion-text color="dark">{{ selectOrder?.totalQty }}Kg</ion-text>
      </td>
      <td class="no-border-left">
        <ion-text font-bold="" color="dark">{{
          totalAmount | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
    <tr
      class="border-box"
      *ngIf="
        !selectOrder?.saleOrder && selectOrder?.status === 'PICKUP_SCHEDULED'
      "
    >
      <td [colSpan]="3" class="no-border"></td>
      <td class="no-border-right" [colSpan]="2">
        <ion-text color="dark">{{ totalLabelText }}</ion-text>
      </td>
      <td [colSpan]="2" class="no-border-left no-border-right">
        <ion-text color="dark">{{ selectOrder?.totalQty }}Kg</ion-text>
      </td>
      <td class="no-border-left">
        <ion-text font-bold="" color="dark">{{
          totalAmount | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
    <tr class="border-box" *ngIf="selectOrder?.status === 'MATERIAL_RECEIVED'">
      <td
        [colSpan]="selectOrder.orderType === 'PICKUP' ? 5 : 3"
        class="no-border"
      ></td>

      <td class="no-border-right" [colSpan]="2">
        <ion-text class="ion-float-left" color="dark">{{
          totalLabelText
        }}</ion-text>
      </td>
      <td class="no-border-left no-border-right">
        <ion-text color="dark">{{ selectOrder?.totalQty }}Kg</ion-text>
      </td>
      <td class="no-border-left no-border-right"></td>
      <td class="no-border-left">
        <ion-text font-bold="" color="dark">{{
          totalAmount | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
    <tr
      class="border-box"
      *ngIf="
        selectOrder?.status === 'ORDER_COMPLETED' &&
        (selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus ===
            'INVOICE_VERIFICATION_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' ||
          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus === 'COMPLETED')
      "
    >
      <td
        [colSpan]="selectOrder.orderType === 'PICKUP' ? 5 : 3"
        class="no-border"
      ></td>

      <td class="no-border-right no-border-bottom" [colSpan]="2">
        <ion-text class="ion-float-left" color="dark">{{
          totalLabelText
        }}</ion-text>
      </td>
      <td class="no-border-left no-border-right no-border-bottom">
        <ion-text *ngIf="selectOrder.orderType === 'DROP'" color="dark"
          >{{ selectOrder?.totalQty }}Kg
        </ion-text>
        <ion-text
          *ngIf="selectOrder.orderType === 'PICKUP'"
          tooltipPosition="top"
          pTooltip="Picked Qty / Received Qty"
          tooltipStyleClass="tooltip-bg-white"
          color="dark"
          >{{ selectOrder?.totalQty }}Kg / {{ selectOrder?.totalReceivedQty }}Kg
        </ion-text>
      </td>
      <td class="no-border-left no-border-bottom">
        <ion-text font-bold="" color="dark">{{
          (totalPay > totalEarn ? totalPay - totalEarn : totalEarn - totalPay)
            | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
    <tr
      class="border-box-2"
      *ngIf="
        selectOrder?.status === 'ORDER_COMPLETED' &&
        (selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus ===
            'INVOICE_VERIFICATION_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' ||
          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus === 'COMPLETED')
      "
    >
      <td
        [colSpan]="selectOrder.orderType === 'PICKUP' ? 5 : 3"
        class="no-border"
      ></td>

      <td class="no-border-right no-border-top no-border-bottom">
        <ion-text class="ion-float-left" color="dark">Total Tax</ion-text>
      </td>
      <td class="no-border" [colSpan]="2"></td>
      <td class="no-border-left no-border-top no-border-bottom">
        <div
          tooltipPosition="top"
          [escape]="false"
          pTooltip="<p>Goods Tax: <ion-text color='primary'>{{
            selectOrder.gstOrder ? selectOrder.totalTax : 0
          }}<ion-text></p> <p> Service Tax: <ion-text color='danger'>{{
            selectOrder.earnTax ? selectOrder.earnTax : 0
          }}<ion-text></p>"
          tooltipStyleClass="tooltip-bg-white"
        >
          <ion-text font-bold="" color="dark" *ngIf="selectOrder.gstOrder">{{
            (totalPay > totalEarn
              ? totalPayTax - totalEarnTax
              : totalEarnTax - totalPayTax
            ) | currency: "INR"
          }}</ion-text>
          <ion-text font-bold="" color="dark" *ngIf="!selectOrder.gstOrder">{{
            totalEarnTax | currency: "INR"
          }}</ion-text>
          <ion-icon
            name="help-circle"
            mode="ios"
            size="small"
            color="grey"
            style="vertical-align: sub; margin-left: 2px"
          ></ion-icon>
        </div>
      </td>
    </tr>
    <tr
      class="border-box-2"
      *ngIf="
        (selectOrder?.status === 'ORDER_COMPLETED' && selectOrder?.gstOrder) ||
        selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||
        selectOrder?.payment?.orderPaymentStatus ===
          'INVOICE_VERIFICATION_PENDING' ||
        selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' ||
        selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING' ||
        selectOrder?.payment?.orderPaymentStatus === 'COMPLETED'
      "
    >
      <td
        [colSpan]="selectOrder.orderType === 'PICKUP' ? 5 : 3"
        class="no-border"
      ></td>

      <td class="no-border-right no-border-top" [colSpan]="3">
        <ion-text font-bold="" class="ion-float-left" color="dark"
          >Net Amount</ion-text
        >
      </td>
      <td class="no-border-left no-border-top">
        <ion-text font-bold="" color="dark">{{
          selectOrder.netAmount | currency: "INR"
        }}</ion-text>
      </td>
    </tr>
  </ng-template>
</p-table>
